/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { DynamicFieldsKanbanWidget } from "./libs/KanbanComp";
import * as S from "../../styles";

export interface IDynamicFieldsProps {
    id: string;
    cardType?: string;
    attributesTitle?: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: any;
    required?: boolean;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const DynamicFields = ({
    id,
    label,
    labelColor,
    errorText,
    value,
    required,
    attributesTitle,
    cardType,
    onCompChange,
    hasError
}: IDynamicFieldsProps) => {
    const onChange = (id: string, e: any) => {
        if (e && e[0] && e[0]?.cards) {
            onCompChange && onCompChange(id, e[0].cards);
        }
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <DynamicFieldsKanbanWidget
                        cardType={cardType}
                        kanbanList={[
                            {
                                title: attributesTitle,
                                cards: value ?? []
                            }
                        ]}
                        onKanbanConfirm={(kanbanLists: any) => {
                            onChange(id, kanbanLists);
                        }}
                    />
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

DynamicFields.defaultProps = {
    required: false,
    attributesTitle: "Attributes",
    cardType: "Attribute",
    hasError: false
};
